import React, { useState } from 'react';
import axios from 'axios';
import './NoticeUploadForm.css'; 
import { Link } from 'react-router-dom';

const API_URL = 'https://ptlrbackend.onrender.com';

const NoticeUploadForm = ({ token, fetchNotices }) => {
  const [formData, setFormData] = useState({ title: '', description: '', image: null });

  const handleUpload = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append('title', formData.title);
    form.append('description', formData.description);
    if (formData.image) form.append('image', formData.image);

    try {
      await axios.post(`${API_URL}/notices`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      fetchNotices();
      setFormData({ title: '', description: '', image: null });
    } catch (error) {
      console.error('Error uploading notice:', error);
    }
  };

  return (
    <div className="upload-form-container">
      <h2 className="upload-form-title">Upload Notice</h2>
      <form className="upload-form" onSubmit={handleUpload}>
        <input
          type="text"
          placeholder="Title"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          required
          className="upload-form-input"
        />
        <textarea
          placeholder="Description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          required
          className="upload-form-textarea"
        ></textarea>
        <input
          type="file"
          onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
          className="upload-form-file-input"
        />
        <button type="submit" className="upload-form-button">Upload</button>
        <div className="Adminbtn">
    <button><Link to="/AdminPanel">Admin</Link></button>
  </div>
      </form>
    </div>
  );
};

export default NoticeUploadForm;